module.exports = __webpack_public_path__ + "img/product-desc3.765eb193.png";